import { render, staticRenderFns } from "./NBASeasonalStatistics.vue?vue&type=template&id=736e567f&"
import script from "./NBASeasonalStatistics.vue?vue&type=script&lang=js&"
export * from "./NBASeasonalStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports